import { Dispatch, memo, SetStateAction, useCallback, useMemo } from "react";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Column } from "@tanstack/table-core";
import { SingleValue } from "react-select";
import { Select } from "../../../../../inputs";
import { renderColumnHeader, renderColumnHeaderAsText } from "../../../../utils";

export type AddFilterProps = {
  availableColumns: Column<any>[]
  unusedColumns: Column<any>[],
  setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>
}

export const AddFilter = memo<AddFilterProps>(({ unusedColumns, availableColumns, setColumnFilters }) => {
  return (
    <Select<Column<any>, false>
      placeholder="Add filter"
      options={unusedColumns}
      getOptionLabel={renderColumnHeaderAsText}
      formatOptionLabel={renderColumnHeader as any}
      rootContainerProps={useMemo(() => ({
        style: {
          gridColumn: unusedColumns.length === availableColumns.length
            ? "1/-1"
            : "1/3",
        },
      }), [ availableColumns.length, unusedColumns.length ])}
      onChange={useCallback((newValue: SingleValue<Column<any>>) => {
        setColumnFilters(
          prevState => {
            const filters = [ ...prevState ];

            if (newValue) {
              filters.push({
                id: newValue.id,
                value: undefined,
              });
            }

            return filters;
          },
        );
      }, [ setColumnFilters ])}
    />
  );
});